import { useSelector } from 'react-redux'
import { messagesSelectors, selectMessages } from 'store/messages'
import { settingsSelectors } from 'store/settings'
import { ChatResponseModeEnum } from 'types/chat'
import { UserMessage } from 'components/messages/UserMessage'
import { TicketInfoCard } from 'components/ui/TicketInfoCard'
import { OperatorMessage } from 'components/messages/OperatorMessage'
import { BotMessage } from 'components/messages/BotMessage'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { ChatMessage, MessageTypeEnum } from 'types/chat-message'
import { getMessageSide, MessageSide } from 'utils/chats'
import { SystemMessage } from 'components/messages/SystemMessage'

export const ChatMessages = () => {
  const { t } = useTranslation()
  const messages = useSelector(selectMessages)
  const currentChatTicket = useSelector(messagesSelectors.currentChatTicket)
  const currentUserId = useSelector(settingsSelectors.userId)
  const isLogged = useSelector(settingsSelectors.isLogged)

  const lastMessageInBotMode = useMemo(() => {
    if (!currentChatTicket) {
      return undefined
    }
    const message = _.findLast(messages, (message) => message.chatResponseMode === ChatResponseModeEnum?.BOT)
    return message?._id
  }, [messages, currentChatTicket])

  const renderMessage = useCallback(
    (message: ChatMessage, i: number) => {
      if (message.type === MessageTypeEnum.SYSTEM) {
        return [<SystemMessage messageItem={message} key={message._id} />]
      }

      const side = getMessageSide(message, currentUserId, isLogged)
      const isLastMessageInBotMode = lastMessageInBotMode === message._id

      const result = []
      if (side === MessageSide.Own) {
        result.push(<UserMessage messageItem={message} key={message._id} />)
      } else if (side === MessageSide.Bot) {
        result.push(
          <BotMessage messageItem={message} key={message._id} index={i} startsSequence={true} endsSequence={false} />,
        )
      } else {
        result.push(
          <OperatorMessage
            messageItem={message}
            key={message._id}
            index={i}
            startsSequence={true}
            endsSequence={false}
          />,
        )
      }
      if (isLastMessageInBotMode) {
        result.push(<TicketInfoCard key={'ticket-info'} />)
      }

      return result
    },
    [lastMessageInBotMode, currentUserId, isLogged],
  )

  return (
    <div
      role="log"
      aria-live="polite"
      aria-relevant="additions text"
      aria-label={t('chat')}
      className={'tw-flex tw-flex-col tw-gap-3'}
    >
      {messages.map(renderMessage)}
    </div>
  )
}
